import React, { useState, useReducer, useEffect } from 'react';
import {
  VirtualTableState,
  SortingState,
  DataTypeProvider,
  FilteringState,
} from '@devexpress/dx-react-grid';
import {
  Grid,
  VirtualTable,
  TableHeaderRow,
  TableColumnResizing,
  TableFilterRow,
} from '@devexpress/dx-react-grid-material-ui';

import utils from '../../utils'
import AuthService from '../../services/auth-service';
import LoadingSpinner from '../../comp/gen/LoadingSpinner';
import UserAuthRequired from '../../comp/gen/UserAuthRequired';
import Badge from '@mui/material/Badge';
import { Link, useNavigate, useParams, useSearchParams } from "react-router-dom";

import AddIcon from '@mui/icons-material/Add';
import Fab from '@mui/material/Fab';

import { Autocomplete, Stack, Paper, Box, Button, Chip, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, InputLabel, MenuItem, Select, TextField } from "@mui/material"
import LinearProgress from '@mui/material/LinearProgress';
import Slider, { SliderThumb } from '@mui/material/Slider';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';
import notify from 'devextreme/ui/notify';

// ************************************************************
// ************************************************************
// ************************************************************

function ValueLabelComponent(props) {
  const { children, value } = props;
  return (
    <Tooltip enterTouchDelay={0} placement="top" title={value}>
      {children}
    </Tooltip>
  );
}

export default function ComputerListDeleteFormDialog(props) {
  
  const [userData, setUserData] = React.useState({})
  
  const handleClose = () => {
    props.onClickClose()
    setUserData({})    
  }
  const handleSubmit = () => {
    console.log(userData)
    props.onClickSubmit(userData)
    setUserData({})    
  }
  const handleTextBoxChange = (e) => {
    //console.log(e.target.value)
    var d = userData
    d[e.target.id] = e.target.value
    setUserData(d)
  }  
  
  // **********************************************************
  // **********************************************************
  // **********************************************************

  var view_en = {
    cancel_button: true,
    build_button: true,
    show_spin: false,
  }  
  
  if (props.spin) {
    view_en.cancel_button = false
    view_en.build_button = false
    view_en.show_spin = true
  }
    
  // **********************************************************
  // **********************************************************
  // **********************************************************
  
  return (    
    <div>      
      <Dialog 
        maxWidth='sm'
        fullWidth={true}
        open={props.open} 
        //onClose={handleClose}
      >
        <DialogTitle>DELETE COMPUTER</DialogTitle>
        <DialogContent>
          <Stack 
            spacing={3}            
          >
              <TextField
                value={userData.user_code} 
                margin="dense"
                required
                id="user_code"
                label="User code"
                onChange={handleTextBoxChange}
                type="text"
                fullWidth
                variant="standard"
                disabled={view_en.show_spin}
                />
              
              <TextField
                value={userData.delete_password} 
                margin="dense"
                required
                id="delete_password"
                label="Delete password"
                onChange={handleTextBoxChange}
                type="text"
                fullWidth
                variant="standard"
                disabled={view_en.show_spin}
                />
              
              
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button disabled={!view_en.cancel_button} onClick={handleClose}>Cancel</Button>
          <Button disabled={!view_en.build_button} onClick={handleSubmit}>Submit</Button>
        </DialogActions>
        {view_en.show_spin && <LinearProgress />}
      </Dialog>
    </div>
  );
}
